import React, { useState } from 'react'
import Login from './components/Login'
import Dashboard from './components/Dashboard'
import DossierDetail from './components/DossierDetail'
import NewDossier from './components/NewDossier'
import { api, hasValidSession } from './api'
import './App.css'

export default function App() {
  const [auth, setAuth] = useState(hasValidSession())
  const [page, setPage] = useState('dashboard')
  const [selectedDossier, setSelectedDossier] = useState(null)

  const handleLogin = () => {
    setAuth(true)
  }

  const handleLogout = () => {
    api.logout()
    setAuth(false)
    setPage('dashboard')
    setSelectedDossier(null)
  }

  const navigate = (p, data = null) => {
    setPage(p)
    if (data) setSelectedDossier(data)
  }

  if (!auth) return <Login onLogin={handleLogin} />

  return (
    <div className="app">
      <header className="app-header">
        <div className="header-left">
          <span className="logo">Eva Pro</span>
          <span className="logo-sub">Interface Facilitateur</span>
        </div>
        <nav className="header-nav">
          <button className={`nav-btn ${page === 'dashboard' ? 'active' : ''}`}
            onClick={() => navigate('dashboard')}>
            Tableau de bord
          </button>
          <button className={`nav-btn ${page === 'new' ? 'active' : ''}`}
            onClick={() => navigate('new')}>
            + Nouveau dossier
          </button>
        </nav>
        <button className="logout-btn" onClick={handleLogout}>Déconnexion</button>
      </header>

      <main className="app-main">
        {page === 'dashboard' && (
          <Dashboard onOpenDossier={(d) => navigate('dossier', d)} onUnauthorized={handleLogout} />
        )}
        {page === 'new' && (
          <NewDossier onCreated={(d) => navigate('dossier', d)} onCancel={() => navigate('dashboard')} />
        )}
        {page === 'dossier' && selectedDossier && (
          <DossierDetail dossier={selectedDossier} onBack={() => navigate('dashboard')} onUnauthorized={handleLogout} />
        )}
      </main>
    </div>
  )
}
